/* eslint-disable no-console */
import { httpClient } from '../lib/http-client'

export class MoisesUpload {
  config: any

  session: any

  constructor(config: any, session: any) {
    this.config = config
    this.session = session
  }

  // eslint-disable-next-line
  async localFile({ file, setCancelSource }: any) {
    const controller = new AbortController()

    if (setCancelSource) {
      setCancelSource({ cancel: () => controller.abort() })
    }

    let result

    try {
      const client = httpClient({
        userToken: this.session.token,
        baseUrl: this.config.apiEndpoint,
        headers: this.config.headers
      })

      const upload = await client.get('/v3/upload', {
        signal: controller.signal
      })

      // Upload file to signed URL
      const uploadResponse = await fetch(upload.signedUrl, {
        method: 'PUT',
        headers: { 'Content-Type': file.type },
        body: file,
        signal: controller.signal
      })

      if (!uploadResponse.ok) {
        throw new Error(`Upload failed: ${uploadResponse.statusText}`)
      }

      if (setCancelSource) setCancelSource(null)

      result = {
        tempLocation: upload.tempFileLocation,
        provider: 'filesystem',
        input: file.name,
        name: file.name.replace(/\.[^/.]+$/, '') // Remove file extension
      }
    } catch (error: any) {
      if (error.name === 'AbortError') {
        console.log(`Request canceled: ${error.message}`)
      } else {
        console.error(error)
        throw error
      }
    }

    return result
  }

  // eslint-disable-next-line
  async externalUrl({ url, urlTitle, setCancelSource }: any) {
    const controller = new AbortController()

    if (setCancelSource) {
      setCancelSource({ cancel: () => controller.abort() })
    }

    let result

    try {
      const client = httpClient({
        userToken: this.session.token,
        baseUrl: this.config.urlDownloadEndpoint,
        headers: this.config.headers
      })

      const data = await client.post(
        '/v1',
        {
          url,
          userToken: this.session.token // We should deprecate this field
        },
        {
          signal: controller.signal
        }
      )

      if (setCancelSource) setCancelSource(null)

      result = {
        duration: data.tmpFile?.duration || null,
        tempLocation: data.tmpFile.name,
        provider: 'url',
        input: data.tmpFile.originalUrl,
        name: urlTitle || data.tmpFile.originalName || url // best guess?
      }
    } catch (error: any) {
      if (error.name === 'AbortError') {
        console.log(`Request canceled: ${error.message}`)
      } else {
        throw error
      }
    }

    return result
  }
}
